// extracted by mini-css-extract-plugin
export var arrow = "_ci-1";
export var content = "_ci-0";
export var highlighted = "_ci-2";